import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { Logo } from "@/components/Logo";
import { COMPANY, SERVICES } from "@/data/site";

export const Footer = () => {
  const year = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();

  const goToServices = () => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(
        () =>
          document
            .getElementById("leistungen")
            ?.scrollIntoView({ behavior: "smooth" }),
        250
      );
    } else {
      document
        .getElementById("leistungen")
        ?.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <footer className="relative overflow-hidden bg-[#0a0a0a] text-white" data-testid="footer">
      <div className="pointer-events-none absolute -left-24 top-0 h-72 w-72 rounded-full bg-[var(--kilic-blue)]/30 blur-[120px]" />
      <div className="pointer-events-none absolute -right-24 bottom-0 h-72 w-72 rounded-full bg-[var(--kilic-green)]/25 blur-[120px]" />

      <div className="relative mx-auto max-w-7xl px-5 py-16 md:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="inline-flex rounded-2xl bg-white p-3 shadow-lg">
              <Logo className="h-14" />
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">
              Sauberkeit ist kein Zufall – sie ist unser Anspruch. Ihr
              zuverlässiger Partner für Gebäudereinigung in {COMPANY.region}.
            </p>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white/80">
              Leistungen
            </h4>
            <ul className="mt-5 space-y-2.5 text-sm text-white/60">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <button
                    onClick={goToServices}
                    className="transition-colors hover:text-[var(--kilic-green)]"
                  >
                    {s.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white/80">
              Kontakt
            </h4>
            <ul className="mt-5 space-y-4 text-sm text-white/70">
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-[var(--kilic-green)]" />
                <span>
                  {COMPANY.street}
                  <br />
                  {COMPANY.city}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 shrink-0 text-[var(--kilic-green)]" />
                <a href={`tel:${COMPANY.phoneTel}`} className="hover:text-white">
                  {COMPANY.phoneDisplay}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 shrink-0 text-[var(--kilic-green)]" />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-white">
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="mt-0.5 h-5 w-5 shrink-0 text-[var(--kilic-green)]" />
                <span>Mo. – Sa. · 08:00 – 18:00 Uhr</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white/80">
              Rechtliches
            </h4>
            <ul className="mt-5 space-y-2.5 text-sm text-white/60">
              <li>
                <Link
                  to="/impressum"
                  data-testid="footer-impressum"
                  className="transition-colors hover:text-[var(--kilic-green)]"
                >
                  Impressum
                </Link>
              </li>
              <li>
                <Link
                  to="/datenschutz"
                  data-testid="footer-datenschutz"
                  className="transition-colors hover:text-[var(--kilic-green)]"
                >
                  Datenschutz
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-white/40 md:flex-row">
          <p>
            © {year} {COMPANY.name}. Alle Rechte vorbehalten.
          </p>
          <p>Gebäudereinigung in {COMPANY.region}</p>
        </div>
      </div>
    </footer>
  );
};
